import React from 'react';

import { AvailablePieceJointeDto } from 'lib_api/lib/api/gen';

import Actions from 'components/ActionAndFileWrapper/Actions/Actions';
import AvailableFiles from 'components/ActionAndFileWrapper/AvailableFiles/AvailableFiles';
import { ProcessInstanceUrl } from 'hooks/dossierAdmin/useFetchProcessInstances';

import AvailableProcessInstances from './AvailableProcessInstances/AvailableProcessInstances';
import { ActionAndFileWrapperType } from './ActionAndFileWrapper';

import './ActionAndFileWrapper.less';

interface ActionAndFileWrapperAdminType extends ActionAndFileWrapperType {
  processInstances: ProcessInstanceUrl[];
  deletePieceJointe: (pieceJointe: AvailablePieceJointeDto) => void;
}

const ActionAndFileWrapperAdmin = ({
  filesList,
  piecesJointesList,
  actions,
  dossierId,
  processInstances,
  deletePieceJointe,
}: ActionAndFileWrapperAdminType): React.ReactElement => {
  return (
    <div className={'ActionsContainer'}>
      {!!processInstances.length && (
        <AvailableProcessInstances processInstances={processInstances} />
      )}
      <AvailableFiles
        files={new Set(filesList)}
        piecesJointes={piecesJointesList}
        dossierId={dossierId}
        deletePieceJointe={deletePieceJointe}
      />
      {!!actions.length && <Actions actions={actions} />}
    </div>
  );
};

export default ActionAndFileWrapperAdmin;
